<template>
  <div>
    <helpers-section-header class="mt-6 mb-8">
      Stock Watchlist Signal Rules
    </helpers-section-header>
    <p>
      Make one or more of your stock watchlists a signal. All stocks in your watchlist will be
      evaluated daily as a trading signal.
    </p>
    <p>
      To add or edit one of your watchlists <router-link to="/watchlists">click here</router-link>.
    </p>
    <v-row density="compact">
      <v-col cols="12">
        <v-table class="my-8">
          <thead>
            <tr>
              <th>Watchlist</th>
              <th>Stocks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="m in watchlists" :key="m.id">
              <td class="py-4">
                <v-checkbox
                  v-model="m.enabled"
                  :label="m.description"
                  color="primary"
                  hide-details
                  class="mt-0"
                />
              </td>
              <td>
                <v-chip
                  v-for="stock in m.stocks"
                  :key="stock.id"
                  small
                  label
                  color="primary text-white"
                  class="ma-1"
                >
                  {{ stock.ticker[0] }} {{ stock.name }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapWritableState } from 'pinia'
import { mapStoreState } from '@/store/helpers'
import cloneDeep from 'lodash/cloneDeep'
export default {
  data() {
    return {
      watchlists: []
    }
  },
  computed: {
    groupTitle() {
      return this.editedIndex === -1 ? 'New Rule Group' : 'Edit Rule Group'
    },
    metricTitle() {
      return this.editedIndex === -1 ? 'New 13F Indicator Rule' : 'Edit Indicator Rule'
    },
    ...mapStoreState({
      groups: state => state.user.watchlists
    }),
    ...mapWritableState(useAppStore, ['whaleTraderCriteria']),
    criteria() {
      return this.whaleTraderCriteria.signals.watchlist_signal
    },
    appcriteria() {
      return this.whaleTraderCriteria
    },
    enabled() {
      return this.whaleTraderCriteria.signals.watchlist_signal.enabled
    }
    /*...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.watchlist_signal',
      enabled: 'app.whaleTraderCriteria.signals.watchlist_signal.enabled',
      signalView: 'app.signalView'
    })*/
  },
  watch: {},
  created() {
    var filters = this.filters
    Promise.all([useUserStore().loadWatchlists()])
      // Include all sectors by default
      .then(() => {
        this.watchlists = []
        for (var i = 0; i < this.groups.length; i++) {
          var g = this.groups[i]
          var wl = { id: g.id, description: g.description, stocks: [], enabled: false }
          for (var j = 0; j < g.stocks.length; j++) {
            var s = g.stocks[j]
            wl.stocks.push({ id: s.id, name: s.name, ticker: s.ticker })
          }
          var found = false
          for (var k = 0; k < this.criteria.watchlists.length; k++) {
            var saved_wl = this.criteria.watchlists[k]
            if (saved_wl.id == wl.id) {
              wl.enabled = saved_wl.enabled
            }
          }
          this.watchlists.push(wl)
        }
        this.syncCriteria()
      })
  },

  methods: {
    //clone watchlists and add enabled field?
    syncCriteria() {
      this.criteria.watchlists = this.watchlists
    }
  }
}
</script>
